module.exports = __webpack_public_path__ + "img/Porto Apartment - 55 of 85.d8acf9d0.jpeg";